<!-- Deprecated: This Vue template is no longer in use -->
<template>
    <div class="card">
        <!-- Header -->
        <div class="card-header p-3">
            <div class="row justify-content-between align-items-center flex-grow-1">
                <div class="col-3">
                    <form :id="idSearchForm" autocomplete="off">
                        <!-- Search -->
                        <div class="input-group input-group-merge">
                            <div class="input-group-prepend input-group-text">
                                <i class="bi-search"></i>
                            </div>
                            <input
                                name="search-term"
                                type="text"
                                class="form-control form-control-sm"
                                :placeholder="$t('Enter search term')"
                                :data-hs-form-search-options=searchOptions
                                :id="idSearchInput"
                            >
                            <AppButton type="submit" btnClass="input-group-append input-group-text">
                                <i
                                    :id="idSearchClearIcon"
                                    class="bi-x-lg"
                                    style="display: none; margin-right: 5em;"
                                />
                            </AppButton>
                            <AppButton type="submit" btnClass="btn-white btn-sm">
                                {{ $t('Search') }}
                            </AppButton>
                        </div>
                        <!-- End Search -->
                    </form>
                </div>
                <div class="col-auto"></div>
                <div class="col-auto">
                    <!-- Filter -->
                    <div class="row align-items-center">
                        <slot name="filters"></slot>
                        <div class="col-auto ps-0">
                            <ColumnSelector
                                :columns="props.columns"
                                @set-visibility="onSetVisibility"
                            />
                        </div>
                        <div class="col" v-if="false">
                            <AppButton @click="dtReload">
                                {{ $t('Reload') }}
                            </AppButton>
                        </div>
                    </div>
                    <!-- End Filter -->
                </div>

                <div class="row mt-3">
                    <slot name="selectedFilters"></slot>
                </div>
            </div>
        </div>
        <!-- End Header -->
        <div class="table-responsive datatable-custom">
            <table :id="props.id" style="min-height: 200px; width: 100%;"
                   class="table table-sm table-hover table-thead-bordered table-nowrap table-align-middle">
                <thead class="thead-light sticky-header">
                </thead>
                <tbody style="min-height: 400px;"></tbody>
            </table>
        </div>
        <!-- Footer -->
        <div class="card-footer p-3">
            <div class="row justify-content-between align-items-center">
                <!-- Left column for datatable info -->
                <div class="col-md-6" :id="idTableInfo"></div>

                <!-- Right column for pagination controls -->
                <div class="col-md-6 mt-3 mt-md-0">
                    <div class="float-end">
                        <nav :id="idPagination" aria-label="Activity pagination"></nav>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Footer -->

        <pre v-show="false">{{ props }}</pre>
    </div>
</template>

<script setup>
import ColumnSelector from "./ColumnSelector.vue";
import { onMounted, ref, h, render } from "vue";
import {trans as $t} from "@/vue/composables/missingTranslations";
import { startCase } from "../helpers";
import AppButton from "@/vue/shared/AppButton.vue";
import AppLoading from "@/vue/shared/AppLoading.vue";

// TODO: remove all default config related to patients
const props = defineProps({
    id: {
        type: String,
        default: 'patients'
    },
    label: {
        type: String,
        //default: 'Patients'
    },
    url: {
        type: String,
        default: "/api/patients/datatable",
    },
    columns: {
        type: Array,
        default: [
            {data: "id"},
            {data: "first_name", title: "!!! 🎉 First Name 🎉 !!!"},
            {data: "last_name",},
            {data: "therapy_start", title: "Setup Date", render: (data) => moment(data).format("MM/DD/YYYY")},
            {data: "created", render: (data) => moment(data).format('MMM D, YYYY')},
        ]
    },
    columnDefs: {
        type: Array,
        default: [{
            targets: '_all',
            defaultContent: '<b> -- </b>',
        }]
    },
    order: {
        type: Array,
        default: []
    },
    pageLength: {
        type: Number,
        default: 50
    },
});

const columns = props.columns;
columns.forEach(col => {
    col.name = col.name || col.data;
    col.title = $t(col.title || startCase( $t(col.name).toLowerCase()) );
})

const DT = HSCore.components.HSDatatables;
const idPagination = `${props.id}Pagination`;
const idTableInfo = `${props.id}TableInfo`;
const idSearchForm = `${props.id}SearchForm`;
const idSearchInput = `${props.id}SearchInput`;
const idSearchClearIcon = `${props.id}SearchClearIcon`;
const searchOptions = `{"clearIcon": "#${idSearchClearIcon}"}`;

const lastSearchTerm = ref('');

function dtInstance() {
    return DT.getItem(props.id);
}

function dtReload() {
    dtInstance().ajax.reload();
}

function onSetVisibility($event, col) {
    dtInstance().column(`${col.name}:name`).visible($event.target.checked)
}

onMounted(() => {
    // INITIALIZATION OF DATA TABLES
    // =======================================================

    // $.fn.dataTable.ext.errMode = 'throw';
    // $.fn.dataTable.ext.errMode = 'none';
    DT.init($(`#${props.id}`), {
        serverSide: true,
        ajax: props.url,
        columnDefs: props.columnDefs,
        columns: props.columns,
        order: props.order,
        searchDelay: 1000,
        pageLength: props.pageLength,
        paging: true,
        pagingType: 'numbers',
        pagination: "" + idPagination,
        processing: true,
        language: {
            loadingRecords: "&nbsp;",
            processing: `
                <div  class="d-flex flex-column p-2 gap-2 align-items-center">
                    <div class="custom-spinner" role="status">
                        <div class="logo-spinner"></div>
                    </div>
                    <span class="visible">${$t('Loading...')}</span>
                </div>
            `,
            zeroRecords: `
                <div class="text-center p-4" style="position: fixed; left: 50vw; transform: translate(-50%, -50%);">
                    <p class="mb-0">${$t('No Records Found')}</p>
                </div>
            `
        },
        search: {
            smart: false
        },
        drawCallback: function() {
            const table = this.api();
            const pageInfo = table.page.info();

            // prevent error when pageInfo is not defined
            if (!pageInfo) {
                return;
            }

            const start = pageInfo.start + 1;
            const end = pageInfo.end;
            const recordsDisplay = pageInfo.recordsDisplay;
            const total = pageInfo.recordsTotal;

            let infoText = `Showing ${start} to ${end} of ${recordsDisplay} entries`;

            // Include records count from total filtered when searching
            if (recordsDisplay !== total) {
                infoText += ` (filtered from ${total} total)`;
            }

            $(`#${idTableInfo}`).text(infoText); // Update the element with the info text
        },
        initComplete: function() {
            $(this.api().table().container()).find('input').parent().wrap('<form>').parent().attr('autocomplete', 'off');
        }
    });

    // INITIALIZATION OF DATE RANGE PICKER
    // =======================================================
    HSCore.components.HSDaterangepicker.init('.js-daterangepicker-clear');

    // INITIALIZATION OF FORM SEARCH
    // =======================================================
    new HSFormSearch(`#${idSearchInput}`);

    // INITIALIZATION OF FLATPICKR
    // =======================================================
    HSCore.components.HSFlatpickr.init(".js-flatpickr");


    // TABLE EVENTS
    // =======================================================

    $(document).on("submit", `#${idSearchForm}`, function(e) {
        e.preventDefault();

        const searchValue = $(this).find("input[name=search-term]").val();

        if (searchValue === lastSearchTerm.value) {
            return;
        }

        if (searchValue === "" && lastSearchTerm.value === "") {
            return;
        }

        dtInstance().search(searchValue).draw();
        lastSearchTerm.value = searchValue;
    });

    $(document).on("click", `#${idSearchClearIcon}`, function(e) {
        if (lastSearchTerm.value !== "") {
            dtInstance().search("").draw();

            lastSearchTerm.value = "";
        }
    });

    $(".js-daterangepicker-clear").on("apply.daterangepicker", function(ev, picker) {
        $(this).val(picker.startDate.format("MM/DD/YYYY") + " - " + picker.endDate.format("MM/DD/YYYY"));
    }).on("cancel.daterangepicker", function(ev, picker) {
        $(this).val("");
    });

});
</script>
<style scoped>

.table-responsive {
    max-height: 400px;
    overflow: auto;
    scrollbar-color: #bbbbbb #ffffff;
    scrollbar-width: thin;
}

.table-responsive::-webkit-scrollbar {
    width: 8px;
}

.table-responsive::-webkit-scrollbar:horizontal {
    width: 8px;
}

.table-responsive::-webkit-scrollbar-thumb {
    background-color: #bbbbbb;
    border-radius: 6px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
    background-color: #777777;
}

.sticky-header {
    position: sticky;
    top: 0;
    z-index: 0;
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.2);
    z-index: 10;
}

th.sortable {
    cursor: pointer;
}

th.sortable.sorting-asc {
    color: var(--bs-primary);
}

th.sortable.sorting-desc {
    color: var(--bs-primary);
}

th.sortable.sorting-asc i {
    font-weight: bolder;
}

th.sortable.sorting-desc i {
    font-weight: bolder;
}
</style>
